export const regionOptions = [
  { title: "India", value: "india" },
  { title: "Middle East", value: "middle-east" },
];
